// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 130 ? "photoEditor" : chunkId) + "." + {"16":"e8b1d59a","79":"491d5bd7","130":"5eb48f4e","912":"ddf0d4c1"}[chunkId] + ".js";
};